export const default_table_html = [
    '<table style="border-collapse: collapse; width: 100%; height: 300px;" border="1">',
    '<tbody>',
    '<tr style="height: 100px;">',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '</tr>',
    '<tr style="height: 100px;">',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '</tr>',
    '<tr style="height: 100px;">',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '<td style="width: 50%; height: 100px; text-align: center; vertical-align: middle;">&nbsp;</td>',
    '</tr>',
    '</tbody>',
    '</table>'
];